import { dateFormatOptions } from "./Dashboard.constants";

// Get current date to display on the UI.
export const formatCurrentDate = (): string => {
  return new Date().toLocaleDateString("en-GB", dateFormatOptions);
};

// Extract the user's first name attribute from AWS Cognito auth profile.
// If the attribute doesn't exist, default to an empty string.
export const extractFirstName = (givenName: string | undefined): string => {
  return givenName ?? "";
};
